import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 3,
  class: "s-notification--list text-center font-header-4 s-mt-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notification_header = _resolveComponent("notification-header")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_notification_list = _resolveComponent("notification-list")!
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createBlock(_component_q_list, { class: "s-notification--wrapper" }, {
    default: _withCtx(() => [
      (_ctx.withHeader)
        ? (_openBlock(), _createBlock(_component_notification_header, {
            key: 0,
            "count-notifications": _ctx.countNotifications,
            onChangeVisibility: _ctx.changeVisibilityNotificationModal,
            onSetAllNotificationReaded: _ctx.setAllNotificationReaded
          }, null, 8, ["count-notifications", "onChangeVisibility", "onSetAllNotificationReaded"]))
        : _createCommentVNode("", true),
      (_ctx.withHeader)
        ? (_openBlock(), _createBlock(_component_q_separator, {
            key: 1,
            size: "3px",
            class: "s-mt-md"
          }))
        : _createCommentVNode("", true),
      (_ctx.countNotifications > 0)
        ? (_openBlock(), _createBlock(_component_notification_list, {
            key: 2,
            notifications: _ctx.notifications,
            onSetNotificationReaded: _ctx.setNotificationAsRead
          }, null, 8, ["notifications", "onSetNotificationReaded"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, " Непрочитанные уведомления отсутствуют ")),
      (_ctx.withFooter)
        ? (_openBlock(), _createBlock(_component_q_item, {
            key: 4,
            style: {"border-top":"3px solid rgba(0, 0, 0, 0.20)"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_s_btn, {
                class: "full-width",
                label: "Перейти ко всем уведомлениям",
                to: { name: 'notifications' },
                onClick: _ctx.goToNotificationsPage
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}